module.exports = __webpack_public_path__ + "img/zj.f4befba.png";